import uuid from 'react-uuid';

const SESSION_UUID = `session-uuid_${process.env.REACT_APP_ID}`;

const getSessionUuid = (): string | null => sessionStorage.getItem(SESSION_UUID);
const setSessionUuid = (value: string): void => sessionStorage.setItem(SESSION_UUID, value);

export const getSessionKey = () => {
  if (getSessionUuid()) {
    return getSessionUuid();
  }

  const key = uuid();
  setSessionUuid(key);

  return key;
};
